export default {
  placeholder: 'Vybrať zákazníka',
};
